import { Regions } from "../../config";
export const triggerCertificateDownload = async (url: string, filename: string) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export const findRegionByDisplayName = (displayName: string) => {
    if (!displayName) {
        console.warn("No region provided. Defaulting to Canada.");
        return Regions.Canada;
    }

    const selectedRegion = Object.values(Regions).find((r) => r.displayName === displayName);

    if (!selectedRegion) {
        const fuzzyMatch = Object.values(Regions).find(
            (r) => displayName.includes(r.displayName) || r.displayName.includes(displayName)
        );

        if (fuzzyMatch) {
            console.warn(
                `Exact region match not found for "${displayName}", but found similar: "${fuzzyMatch.displayName}"`
            );
            return fuzzyMatch;
        }

        console.warn(
            `Region not found: "${displayName}". Available regions:`,
            Object.values(Regions).map((r) => r.displayName),
            "Defaulting to Canada."
        );
        return Regions.Canada;
    }

    return selectedRegion;
};
